import { Component, Injector, ViewEncapsulation, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';

@Component({
  selector: 'app-appoinment-list',
  templateUrl: './appoinment-list.component.html',
  styleUrls: ['./appoinment-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AppoinmentListComponent implements OnInit {

  public gridData: [];
  public pageSize = 50;
  public skip = 0;
  public pageSizes = [
    { text: 50, value: 50 },
    { text: 100, value: 100 },
    { text: 150, value: 150 }
  ];
  private data: Object[];

  private items: any[];

  constructor(
    private _router: Router
  ) {
    this.loadItems();
  }

  ngOnInit() {
    this.loadItems();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }

  private loadItems(): void {
    // this.gridData = {
    //   data: this.items.slice(this.skip, this.skip + this.pageSize),
    //   total: this.items.length
    // };
  }

}


